import { Component, ViewChild } from '@angular/core';
import {
  Nav,
  Platform,
  ModalController,
  AlertController,
  LoadingController,
  IonicApp,
  ToastController,
  MenuController,
} from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Push, PushObject, PushOptions } from '@ionic-native/push';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { Events } from 'ionic-angular';
import { UserProvider } from '../providers/user/user';
import { OracaoProvider } from '../providers/oracao/oracao';
import { Storage } from '@ionic/storage';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { environment } from '../environments/environment';
import * as moment from 'moment';

declare var instituicaoConstants;
declare var browserDefault;

@Component({
  templateUrl: 'app.html',
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  rootPage: any = '';
  version: string = '';
  usuario: any = { id: 0, nome: '', foto: '', instituicao: {} };
  public isPwa: boolean = instituicaoConstants.IS_PWA;
  public linguagem: string = instituicaoConstants.LINGUAGEM ? instituicaoConstants.LINGUAGEM : 'pt';
  pages: Array<{ title: string; component: any; icon: string }>;
  fcmId: any = '';

  loader = this.loadingController.create({
    content: 'Atualizando',
  });

  constructor(
    public platform: Platform,
    public statusBar: StatusBar,
    public splashScreen: SplashScreen,
    public translate: TranslateService,
    public modalCtrl: ModalController,
    private alertCtrl: AlertController,
    public userProvider: UserProvider,
    public events: Events,
    public loadingController: LoadingController,
    public plt: Platform,
    private menuCtrl: MenuController,
    public push: Push,
    public http: HttpClient,
    private iab: InAppBrowser,
    public oracaoProvider: OracaoProvider,
    public ionicApp: IonicApp,
    private storage: Storage,
    public toastCtrl: ToastController,
  ) {
    moment.locale(this.linguagem == 'pt' ? 'pt-BR' : this.linguagem);

    this.initializeApp();

    //muda o push token
    this.events.subscribe('changeTokenPush', (eventData) => {
      this.initPushNotification();
    });

    events.subscribe('user:login', (user) => {
      this.usuario = user;
    });

    //versionamento PWA e start da notification no pwa
    if (instituicaoConstants.IS_PWA === true) {
      // this.initPushNotificationBrowser();
      this.versionamentoBrowser();
    }
  }

  versionamentoBrowser() {
    this.http
      .get('assets/info/info.json?t=' + new Date().getTime())
      .map((res) => <any>res)
      .subscribe((data) => {
        this.userProvider.getVersion().then((v) => {
          if (!v) {
            this.userProvider.setVersion(data.version);
          } else if (v != data.version) {
            this.userProvider.setVersion(data.version);

            this.loader.present();

            caches.keys().then((keys) => {
              keys.forEach((key) => caches.delete(key));
            });

            setTimeout(() => document.location.reload(true), 2000);
          } else {
            console.log('atualizado:' + v);
          }
        });
      });
  }

  // async initPushNotificationBrowser() {
  //   //firebase.initializeApp(firebase_options);
  //   await this.notificacaoProvider.init();
  // }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    this.nav.push(page.component);
  }

  initPushNotification() {
    // to check if we have permission
    this.push.hasPermission().then((res: any) => {
      if (res.isEnabled) {
        console.log("We have permission to send push notifications");
      } else {
        console.log("We don't have permission to send push notifications");
      }
    });

    // to initialize push notifications
    const options: PushOptions = {
      android: {
        senderID: instituicaoConstants.PROVER_FIREBASE,
        icon: "notification",
        iconColor: "#D3D3D3",
        clearNotifications: false,
        clearBadge: false,
        forceShow: true,
      },
      ios: {
        alert: "true",
        badge: true,
        clearBadge: false,
        sound: "true",
      },
      windows: {},
      browser: {},
    };

    const pushObject: PushObject = this.push.init(options);
    pushObject.setApplicationIconBadgeNumber(0).then((data) => {});
    pushObject.on("error").subscribe((error) => console.log(error));
    pushObject.on('registration').subscribe((registration: any) => {
      this.fcmId = registration.registrationId;

      var platform = "";
      if (this.platform.is("android")) {
        platform = "ANDROID";
      } else if (this.platform.is("ios")) {
        platform = "IOS";
      }

      this.userProvider.getDados().then((res) => {
        if (res) {
          this.http
            .get("assets/info/info.json?t=" + new Date().getTime())
            .map((res) => <any>res)
            .subscribe((data) => {
              this.userProvider
                .setTokenPush(
                  this.fcmId,
                  platform,
                  data.version,
                  res.instituicao.id
                )
                .subscribe(() => {});
            });
        }
      });
    });

    pushObject.on('notification').subscribe((notification: any) => {
      if (notification.additionalData.coldstart) {
        //clicando na notificacao com o app fechado
        this.storage.set("lastNotification", notification);

        this.tratarPush(notification);
      } else if (notification.additionalData.foreground) {
        //recebendo notificao com o app aberto
        this.storage.set("lastNotification", notification);

        let confirmAlert = this.alertCtrl.create({
          title: this.translate.instant("Nova Notificação"),
          subTitle: notification.title,
          message: notification.message,
          buttons: [
            {
              text: this.translate.instant("Ignorar"),
              role: "cancel",
            },
            {
              text: this.translate.instant("Visualizar"),
              handler: () => {
                this.tratarPush(notification);
              },
            },
          ],
        });
        confirmAlert.present();
      } else {
        //clicando na notificacao com o app aberto
        this.storage.set("lastNotification", notification);
        this.tratarPush(notification);
        this.checkForStoredNotification();
      }
    },(error: any) => {
      console.error('Erro ao receber notificação:', error);
    }
   );
  }

  checkForStoredNotification() {
    this.storage.get("lastNotification").then((notification) => {
      if (notification) {
        this.tratarPush(notification);
        this.storage.remove("lastNotification");
      }
    });
  }

  tratarPush(notification) {
    if (notification.additionalData.dadosApp) {
      if (notification.additionalData.dadosApp.entidade == 'culto') {
        let data = {
          idCulto: notification.additionalData.dadosApp.idEntidade,
          dataInicio: notification.additionalData.dadosApp.extras.dataInicio,
          idCultoAgenda: 0,
        };
        let modalPage = this.modalCtrl.create('CultoDetalhesPage', data);
        modalPage.present();
      } else if (notification.additionalData.dadosApp.entidade == 'cultoagenda') {
        let data = {
          idCulto: notification.additionalData.dadosApp.extras.idCulto,
          dataInicio: notification.additionalData.dadosApp.extras.dataInicio,
          idCultoAgenda: notification.additionalData.dadosApp.idEntidade,
        };
        let modalPage = this.modalCtrl.create('CultoDetalhesPage', data);
        modalPage.present();
      } else if (notification.additionalData.dadosApp.entidade == 'grupo') {
        let data = {
          id: notification.additionalData.dadosApp.idEntidade,
          tipo: '1',
          aba: notification.additionalData.dadosApp.extras.aba,
        };
        let modalPage = this.modalCtrl.create('GrupoDetalhesPage', data);
        modalPage.present();
      } else if (notification.additionalData.dadosApp.entidade == 'ministerio') {
        let data = {
          id: notification.additionalData.dadosApp.idEntidade,
          tipo: '2',
          aba: notification.additionalData.dadosApp.extras.aba,
        };
        let modalPage = this.modalCtrl.create('GrupoDetalhesPage', data);
        modalPage.present();
      } else if (notification.additionalData.dadosApp.entidade == 'mda') {
        let data = { id: notification.additionalData.dadosApp.idEntidade };
        let modalPage = this.modalCtrl.create('MdaDetalhesPage', data);
        modalPage.present();
      } else if (notification.additionalData.dadosApp.entidade == 'mensagem') {
        let modalPage = this.modalCtrl.create('MensagemDetailPage', {
          id: notification.additionalData.dadosApp.idEntidade,
        });
        modalPage.present();
      } else if (notification.additionalData.dadosApp.entidade == 'oracao') {
        if (notification.additionalData.dadosApp.extras.equipe == '1') {
          let modalPage = this.modalCtrl.create('OracaoAdmPage');
          modalPage.present();
        } else {
          let modalPage = this.modalCtrl.create('OracaoPage');
          modalPage.present();
        }
      } else if (notification.additionalData.dadosApp.entidade == 'noticia') {
        let modalPage = this.modalCtrl.create('NoticiaDetalhesPage', {
          id: notification.additionalData.dadosApp.idEntidade,
        });
        modalPage.present();
      } else if (notification.additionalData.dadosApp.entidade == 'evento') {
        let modalPage = this.modalCtrl.create('EventoDetalhesPage', {
          id: notification.additionalData.dadosApp.idEntidade,
          tipo: '1',
        });
        modalPage.present();
      } else if (notification.additionalData.dadosApp.entidade == 'ensino') {
        let modalPage = this.modalCtrl.create('EventoDetalhesPage', {
          id: notification.additionalData.dadosApp.idEntidade,
          tipo: '2',
        });
        modalPage.present();
      } else if (notification.additionalData.dadosApp.entidade == 'aniversariantes') {
        let modalPage = this.modalCtrl.create('AniversariantesPage');
        modalPage.present();
      } else if (notification.additionalData.dadosApp.entidade == 'enquete') {
        let data = {
          idEnquete: notification.additionalData.dadosApp.idEntidade,
        };
        let modalPage = this.modalCtrl.create('EnqueteListaPage', data);
        modalPage.present();
      } else if (notification.additionalData.dadosApp.entidade == 'acompanhamento') {
        let modalPage = this.modalCtrl.create('AcompanhamentoPage');
        modalPage.present();
      }
    }
  }

  perfil(idPessoa) {
    let data = { idPessoa: idPessoa, meuCadastro: true };
    var modalPage = this.modalCtrl.create('ModalPessoaPage', data);
    modalPage.present();
  }

  qrcode(idPessoa, nome) {
    let data = { idPessoa: idPessoa, nome: nome };
    var modalPage = this.modalCtrl.create('QrcodePage', data);
    modalPage.present();
  }

  configuracao() {
    let modalPage = this.modalCtrl.create('ConfiguracaoPage');
    modalPage.present();
  }

  relatorios() {
    const url = `${environment.PORTAL_URL}/inicio?appKey=${this.usuario.apiKey}`;
    const browser = this.iab.create(url, '_system', 'location=yes');
    browser.on('exit').subscribe(() => {});
  }

  login() {
    let modalPage = this.modalCtrl.create('LoginPage', { mostrarHeader: true });
    modalPage.present();
  }

  politicas() {
    var modalPage = this.modalCtrl.create('PrivacidadePage');
    modalPage.present();
  }

  initializeApp() {
    this.platform.ready().then(async () => {
      this.userProvider.getDados().then((res) => {
        var url = window.location.href;

        //gambi para tratar contribua
        if (url.replace(/.*pc=([^&]*).*|(.*)/, '$1').split('#')[0]) {
          url = url.replace('u=', '&u=');
        }

        var token = url.replace(/.*t=([^&]*).*|(.*)/, '$1').split('#')[0];
        var cadastroToken = url.replace(/.*c=([^&]*).*|(.*)/, '$1').split('#')[0];
        var user = url.replace(/.*u=([^&]*).*|(.*)/, '$1').split('#')[0];
        var idNoticia = url.replace(/.*n=([^&]*).*|(.*)/, '$1').split('#')[0];
        var idPlanoContribuicao = url.replace(/.*pc=([^&]*).*|(.*)/, '$1').split('#')[0];

        if (instituicaoConstants.IS_PWA) {
          delete window.open;
          window.open = browserDefault;
        }

        this.userProvider.isLoggedin().then((login) => {
          var cadastro: any = {};

          //CADASTRO EXTERNO OVELINHAS
          if (
            token &&
            instituicaoConstants.IS_PWA &&
            cadastroToken == '0' &&
            (this.userProvider.isAnonimo() || !login)
          ) {
            cadastro.form = 'APP_EXT_OVEL';
            cadastro.idPessoaTipo = 5;
            cadastro.titulo = this.translate.instant('Novo Cadastro');
            cadastro.idInstituicao = token;
            cadastro.encrypt = true;
            cadastro.hideBack = true;
            this.nav.setRoot('FormGeradorPage', cadastro);
          }
          //CADASTRO EXTERNO
          else if (
            token &&
            instituicaoConstants.IS_PWA &&
            cadastroToken == '1' &&
            (this.userProvider.isAnonimo() || !login)
          ) {
            cadastro.form = 'APP_CAD_INICIO';
            cadastro.idPessoaTipo = 5;
            cadastro.titulo = this.translate.instant('Novo Cadastro');
            cadastro.idInstituicao = token;
            cadastro.encrypt = true;
            cadastro.hideBack = true;
            this.nav.setRoot('FormGeradorPage', cadastro);
          } else if (instituicaoConstants.IS_PWA && idNoticia) {
            this.nav.setRoot('NoticiaCompartilharPage', { id: idNoticia });
          }
          //compartilhamento de contribuicao
          else if (instituicaoConstants.IS_PWA && idPlanoContribuicao && user) {
            this.userProvider.getUserByToken(user).subscribe((usuarioCompartilhamento) => {
              //compartilhamento de contribuicao com login

              if (
                login &&
                !this.userProvider.isAnonimo() &&
                res.instituicao &&
                usuarioCompartilhamento.instituicao.id == res.instituicao.id
              ) {
                Promise.all([
                  this.storage.set('contribua_hideback', true),
                  this.storage.set('contribua_login', true),
                  this.storage.set('contribua_idPlanoContribuicao', idPlanoContribuicao),
                ]).then((value) => (window.location.href = window.location.origin + '/#/contribua'));
              }
              //compartilhamento de contribuicao sem login
              else {
                this.storage.set('token', user).then((data) => {
                  this.userProvider.atualizarDadosPessoa().subscribe((data) => {
                    this.translate.setDefaultLang(this.linguagem);

                    Promise.all([
                      this.storage.set('contribua_hideback', true),
                      this.storage.set('contribua_login', false),
                      this.storage.set('contribua_idPlanoContribuicao', idPlanoContribuicao),
                    ]).then((value) => (window.location.href = window.location.origin + '/#/contribua'));
                  });
                });
              }
            });
          }
          //contribuicao vindo do app (clicando em contribua e indo para um PWA)
          else if (user && instituicaoConstants.IS_PWA) {
            this.userProvider.loginByToken(user).subscribe((data) => {
              if (!data.error) {
                Promise.all([
                  this.storage.set('contribua_hideback', true),
                  this.storage.set('contribua_login', true),
                  this.storage.set('contribua_idPlanoContribuicao', idPlanoContribuicao),
                ]).then((value) => (window.location.href = window.location.origin + '/#/contribua'));
              } else {
                const toast = this.toastCtrl.create({
                  message: this.translate.instant(data.message),
                  duration: 3000,
                });
                toast.present();
              }
            });
          } else if (res) {
            if (this.checkIsContribua()) {
              this.nav.setRoot('ContribuaPage');
            } else {
              this.userProvider.idInstituicao = res.instituicao.id;
              this.rootPage = 'HomeCustomPage';
              this.userProvider.getIdioma().then(() => {});
            }
          } else if (!res && instituicaoConstants.TOKEN_ANONIMO) {
            this.storage.set('token', instituicaoConstants.TOKEN_ANONIMO).then((data) => {
              this.userProvider.atualizarDadosPessoa().subscribe((data) => {
                this.rootPage = 'HomeCustomPage';
                this.translate.setDefaultLang(this.linguagem);
              });
            });
          } else {
            this.rootPage = 'LoginPage';
            this.translate.setDefaultLang(this.linguagem);
          }
        });

        this.statusBar.styleDefault();
        if (this.platform.is('android')) {
          this.statusBar.styleBlackOpaque();
        }
        this.splashScreen.hide();
      });

      if (!instituicaoConstants.IS_PWA) {
        this.initPushNotification();
      }

      this.platform.registerBackButtonAction(() => {
        try {
          let activePortal =
            this.ionicApp._loadingPortal.getActive() ||
            this.ionicApp._modalPortal.getActive() ||
            this.ionicApp._toastPortal.getActive() ||
            this.ionicApp._overlayPortal.getActive();

          let view = this.nav.getActive();
          let currentRootPage = view.component;
          console.log(activePortal);
          if (activePortal) {
            activePortal.dismiss();
          } else if (this.nav.canGoBack() || (view && view.isOverlay)) {
            this.nav.pop();
          } else if (currentRootPage != this.pages[0].component) {
            // Could any other page that you consider as your main one
            this.openPage(this.pages[0]);
          } else {
            this.showAlertSair();
          }
          return;
        } catch (error) {
          console.log(error);
          this.showAlertSair();
        }
      }, 1);
    });
  }

  showAlertSair() {
    let confirmAlert = this.alertCtrl.create({
      title: this.translate.instant('Atenção'),
      message: this.translate.instant('Deseja sair do aplicativo?'),
      buttons: [
        {
          text: this.translate.instant('Não'),
          role: 'cancel',
        },
        {
          text: this.translate.instant('Sim'),
          handler: () => {
            this.platform.exitApp();
          },
        },
      ],
    });
    confirmAlert.present();
  }

  inicio() {
    this.nav.popToRoot();
  }

  atualizar() {
    var loader = this.loadingController.create({
      content: 'Atualizando',
    });

    loader.present();

    caches.keys().then((keys) => {
      keys.forEach((key) => caches.delete(key));
    });

    setTimeout(() => document.location.reload(true), 2000);
  }

  checkIsContribua() {
    let params = window.location.href.split('/#/');
    let url = params[params.length - 1];
    if (url && url == 'contribua') {
      return true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts